import React from 'react';
import PropTypes from 'prop-types';

const PdpRespTradeNegotiationModal = React.lazy(() =>
    import(/* webpackChunkName: "TradeNegotiationModalLoaderChunk" */ './PdpRespTradeNegotiationModal')
);

export function PdpRespTradeNegotiationModalLoader({ environment, userId, currency, itemId }) {
    return (
        <React.Suspense fallback={null}>
            <PdpRespTradeNegotiationModal
                environment={environment}
                userId={userId}
                currency={currency}
                itemId={itemId}
            />
        </React.Suspense>
    );
}

PdpRespTradeNegotiationModalLoader.propTypes = {
    environment: PropTypes.object,
    userId: PropTypes.string,
    currency: PropTypes.string,
    itemId: PropTypes.string,
};
